/* unplugin-vue-components disabled */import script from "./date-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./date-table.vue?vue&type=script&lang=ts&setup=true"

import "./date-table.vue?vue&type=style&index=0&id=58af9bba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58af9bba"]])

export default __exports__